<style scoped>
    @import url("../../../styles/smartControl/cardEditRGP.scss");
</style>

<template>
    <div class="box_cardEditRGP mt-2">

        <v-dialog v-model="flagDialog" max-width="250px">
            <DialogMSG
                v-if="flagDialog && !flagLoading"
                :msgFromFather="msgFromFather"
                @fromDialogMsg="flagDialog = false"
            />
        </v-dialog>

        <div
            v-if="flagLoading"
            class="mb-16 mt-16"
            style="display: flex; width: 100%; align-items: center; justify-content: center;"
        >
            <v-progress-circular
                color="black"
                size="64"
                indeterminate
            />
        </div>

        <div class="linhaZero" v-if="!flagDialog && !flagLoading">
            <v-chip class="ml-1" size="x-small" color="white">
                {{ 'Grupo (' + currentGroup.group + ') em edição' }}
            </v-chip>
            <v-icon class="ml-1" size="32">mdi-pen</v-icon>
        </div>

        <div class="linhaUm mt-4" v-if="!flagDialog && !flagLoading">
            <div class="colUm">

                <div class="linhaForm">
                    <span class="tLinha">Nome do grupo</span>
                    <v-divider vertical class="mx-1" style="height: 30px;" />

                    <div class="elInput">
                        <v-text-field
                            v-model="currentGroup.name"
                            class="w-100"
                            color="#1F7AB1"
                            bg-color="transparent"
                            variant="plain"
                            rounded="sm"
                            density="compact"
                            hide-details
                            @update:modelValue="changeInfo()"
                        />
                    </div>
                </div>

                <div v-for="key in numericKeys" :key="key" class="linhaForm">
                    <span class="tLinha">{{ key }}</span>
                    <v-divider vertical class="mx-1" style="height: 30px;" />
                    <div class="elInput">
                        <v-text-field
                            v-model="currentGroup[key]"
                            type="text"
                            inputmode="decimal"
                            class="w-100"
                            color="#1F7AB1"
                            bg-color="transparent"
                            variant="plain"
                            rounded="sm"
                            density="compact"
                            hide-details
                            @update:modelValue="changeInfo()"
                        />
                    </div>
                </div>

                <div class="linhaForm">
                    <span class="tLinha">valves</span>
                    <v-divider vertical class="mx-1" style="height: 30px;" />

                    <div style="display: flex; flex-direction: column; flex: 1; min-width: 0;">
                        <div class="d-flex flex-wrap">
                            <v-chip
                                v-for="(valve, index) in currentGroup.valves"
                                :key="index"
                                class="ma-1"
                                size="small"
                                closable
                                @click:close="removeValve(index)"
                            >
                                {{ 'Válvula ' + valve }}
                            </v-chip>
                        </div>

                        <div class="elSelect">
                            <v-autocomplete
                                v-model="selectedValve"
                                :items="availableValves"
                                color="#1F7AB1"
                                class="w-100"
                                variant="plain"
                                bg-color="transparent"
                                density="compact"
                                hide-details
                                placeholder="Adicionar válvula"
                                @update:modelValue="addValve($event)"
                            />
                        </div>
                    </div>
                </div>

            </div>
        </div>

        <v-btn
            v-if="flagBtnEnd && !flagDialog && !flagLoading"
            @click="sendInfo()"
            style="color: green;"
        >
            <span class="txt_btn_irrig">Atualizar</span>
        </v-btn>

        <span v-if="flagMSG" class="txt_btn_irrig">{{ msg }}</span>

    </div>
</template>

<script>
import axios from 'axios'
import DialogMSG from './DialogMSG.vue'

export default {
    props: ['group', 'tok'],

    components: { DialogMSG },

    data() {
        return {
            currentGroup: null,
            originalGroup: null,
            selectedValve: null,
            
            // valvulas já associadas em 19/10/2026
            valvesOptions2select:[0, 1, 2, 3, 4, 10, 11, 12, 13, 14, 15, 19, 20, 21],

            numericKeys: [
                'fertilizationTime',
                'postIrrigationTime',
                'preIrrigationTime',
                'fertilizationVolume',
                'postIrrigationVolume',
                'preIrrigationVolume',
                'fertilizerFormula',
                'preFertilizerFormula',
                'postFertilizerFormula',
                'pump1',
                'pump2',
                'pump3'
            ],

            flagBtnEnd: false,
            flagLoading: false,
            flagDialog: false,
            flagMSG: false,
            msg: '',
            msgFromFather: ''
        }
    },

    computed: {
        availableValves() {
            let available = []

            for (const valve of this.valvesOptions2select) {
                if (!this.currentGroup.valves.includes(valve)) {
                    available.push(valve)
                }
            }

            return available
        },
    },

    methods: {
        addValve(valve) {
            if (!Number.isInteger(valve)) return

            if (!this.currentGroup.valves.includes(valve)) {
                this.currentGroup.valves.push(valve)
                this.changeInfo()
            }

            this.$nextTick(() => {
                this.selectedValve = null
            })
        },

        removeValve(index) {
            this.currentGroup.valves.splice(index, 1)
            this.changeInfo()
        },

        getUpdates() {
            let updates = {}

            if (this.currentGroup.name !== this.originalGroup.name) {
                updates.name = this.currentGroup.name
            }

            for (const key of this.numericKeys) {
                let value = this.currentGroup[key]
                let original = this.originalGroup[key]

                if (value == null || String(value).trim() === '') {
                    throw new Error(`Preencha o campo ${key}`)
                }

                value = Number(String(value).replace(',', '.'))

                if (!Number.isFinite(value)) {
                    throw new Error(`Valor inválido em ${key}`)
                }

                if (original != null && String(original).trim() !== '') {
                    original = Number(String(original).replace(',', '.'))
                }

                if (value !== original) {
                    updates[key] = value
                }
            }

            const valves = this.currentGroup.valves

            if (!Array.isArray(valves)) {
                throw new Error('valves deve ser uma lista')
            }

            for (const valve of valves) {
                if (!Number.isInteger(valve) || valve < 0) {
                    throw new Error('valves deve conter apenas inteiros não negativos')
                }
            }

            if (JSON.stringify(valves) !== JSON.stringify(this.originalGroup.valves)) {
                updates.valves = [...valves]
            }

            return updates
        },

        changeInfo() {
            this.flagMSG = false

            try {
                this.flagBtnEnd = Object.keys(this.getUpdates()).length > 0
            } catch (e) {
                this.flagBtnEnd = false
                this.msg = e.message
                this.flagMSG = true
            }
        },

        async sendInfo() {
            let updates

            try {
                updates = this.getUpdates()
            } catch (e) {
                this.msg = e.message
                this.flagMSG = true
                return
            }

            if (Object.keys(updates).length === 0) {
                this.msg = 'Nenhuma alteração identificada'
                this.flagMSG = true
                this.flagBtnEnd = false
                return
            }

            this.flagMSG = false
            this.flagLoading = true

            try {
                const headers = {
                    'Authorization': `Bearer ${this.$store.state.tox}`,
                    'Xilema-Auth': `Bearer ${this.tok}`,
                    'Content-Type': 'application/json'
                }

                const params = {
                    group_id: this.currentGroup.group,
                    updates: updates
                }

                const rota =
                    this.$store.state.pathAxiosBASE + '/postxgroupxbyxid'

                const res = await axios.post(rota, params, { headers })
                const rcv = res.data.result ?? res.data

                console.log('rcv:', rcv)

                if (rcv.error === false) {
                    // Atualizar a referência local após aceitação do envio.
                    for (const key of Object.keys(updates)) {
                        this.currentGroup[key] = updates[key]
                    }

                    this.originalGroup = JSON.parse(
                        JSON.stringify(this.currentGroup)
                    )

                    this.msgFromFather = 'Atualizado.'
                    this.flagBtnEnd = false
                } else {
                    this.msgFromFather = 'Não foi possível atualizar. Tente novamente mais tarde.'
                }
            } catch (e) {
                console.log('[sendInfo] erro:', e.response?.data ?? e.message)

                this.msgFromFather =
                    'Não foi possível atualizar. Tente novamente mais tarde.'
            } finally {
                this.flagLoading = false
                this.flagDialog = true
            }
        }
    },

    created() {
        //console.log('this.group: ',this.group)
        this.currentGroup = JSON.parse(JSON.stringify(this.group))
        this.originalGroup = JSON.parse(JSON.stringify(this.group))
        //console.log('this.currentGroup.valves: ',this.currentGroup.valves)
        //this.valvesText = JSON.stringify(this.currentGroup.valves)
    }
}
</script>
